import React from "react"

import { SidebarNav as BaseSidebarNav } from "gatsby-interface"
import styled from "@emotion/styled"
import { StandardSingleColumn } from "@modules/ui/layouts/Containers"

export const Content = styled(`div`)(p => ({
  alignItems: `start`,
  display: `grid`,
  gridGap: p.theme.space[7],
  width: `100%`,
  minWidth: 0,
  gridTemplateColumns: `100%`,
}))

const Sidebar = styled(`aside`)(p => ({
  width: `14rem`,
  paddingRight: p.theme.space[8],
  paddingBottom: p.theme.space[8],
}))

const SidebarNav = styled(BaseSidebarNav)(p => ({
  position: `sticky`,
  top: p.theme.space[8],
}))

export const InnerLayout = styled(StandardSingleColumn)(p => ({
  display: `flex`,
  flexDirection: `column`,

  [p.theme.mediaQueries.desktop]: {
    flexDirection: `row`,
  },
}))

export function SidebarColumn({ options }) {
  return (
    <Sidebar>
      <SidebarNav options={options} />
    </Sidebar>
  )
}
